<template>
  <div class="xy-lucky-btn" ref="componentRef"></div>
</template>

<script setup>
import { info, defaultProps } from './config'
import { useLucky } from '@/packages/components/hook/useLucky'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)

const { componentRef, getConfig, startRoulette, againRoulette, closeDialog, refreshMoneyBalances } = useLucky(props)

defineExpose({
  getConfig,
  startRoulette,
  againRoulette,
  closeDialog,
  refreshMoneyBalances
})
</script>

<style lang="scss" scoped>
.xy-lucky-btn {
  position: absolute;
  width: 0px;
  height: 0px;
  display: flex;
  top: -10px;
  left: -10px;
  z-index: -999;
}
</style>
